import React  from 'react';
//import { useRecoilValue } from "recoil";
import { useNavigate } from 'react-router-dom' ;
import { useRecoilValue_TRANSITION_SUPPORT_UNSTABLE } from "recoil";
import { historyRouteState } from "src/store/global/historyState";
import { userState } from "src/store/user/userState";

const Logo = () => {

    const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);
    const historyRoute = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(historyRouteState);
    const rootPathServer = process.env.REACT_APP_ROOT_SERVER_PATH;

    const navigate = useNavigate();

    const onclickLogoAction = () => {
        if(user && user.isAuthenticated) {
            //historyRoute.push(`${rootPathServer}/paciente/reservas`);
            navigate(`${rootPathServer}/paciente/reservas`);
        } else {
            //historyRoute.push(`${rootPathServer}`);
            navigate(`${rootPathServer}`);
        }
    }

    return (
        <>
            <img
                style={{ cursor: 'pointer' }}
                src={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/logos/${process.env.REACT_APP_LOGO}`}
                width="140"
                alt="Logo Andes Salud"
                onClick={onclickLogoAction}
                title="Ir a la página principal"
            />
        </>
    )
}

export default Logo;